import { render, staticRenderFns } from "./WidgetEarningsChart.vue?vue&type=template&id=37d5113a"
import script from "./WidgetEarningsChart.vue?vue&type=script&lang=js"
export * from "./WidgetEarningsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports